import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "m-20"
};
const _hoisted_2 = {
  class: "wrap text-black"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("main", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
    class: "bg_white searchBox"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        ref: "form",
        model: $data.filter,
        "label-width": "100px",
        class: "m-t-20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "供应商",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.supplier,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.filter.supplier = $event),
                placeholder: "请输入单个供应商名称查询"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "采购订单号",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.pur_order_sn,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.filter.pur_order_sn = $event),
                placeholder: "仅支持单个采购订单号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "销售订单号",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.sale_order_sn,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.filter.sale_order_sn = $event),
                placeholder: "仅支持单个销售订单号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "送货单号",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.delivery_order_sn,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.filter.delivery_order_sn = $event),
                placeholder: "仅支持单个送货单号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "sku/产品型号",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.sku,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.filter.sku = $event),
                placeholder: "搜索多个sku时用逗号隔开"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "检测状态",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: $data.filter.status,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.filter.status = $event),
                placeholder: "请选择检测状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: "-1"
                }), _createVNode(_component_el_option, {
                  label: "已检测",
                  value: "0"
                }), _createVNode(_component_el_option, {
                  label: "未检测",
                  value: "1"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4,
            offset: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchClick
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("搜索")])),
              _: 1,
              __: [8]
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.reset
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("重置")])),
              _: 1,
              __: [9]
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bg_white m-t-20"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "m-t-20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6,
          class: "m-l-40"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[6] || (_cache[6] = $event => $options.makeSure(1))
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("确认")])),
            _: 1,
            __: [10]
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = $event => $options.makeSure(0))
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("反确认")])),
            _: 1,
            __: [11]
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_table, {
        class: "m-20",
        data: $data.tableData,
        style: {
          "width": "auto"
        },
        border: "",
        ref: "multipleTable",
        "header-cell-style": $data.header_style,
        onSelectionChange: $options.handleSelectionChange,
        "row-key": $data.getRowKeys
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          "reserve-selection": true,
          width: "55",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "sale_order_sn",
          label: "销售订单号",
          width: "180",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "pur_order_sn",
          label: "采购订单号",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "delivery_order_sn",
          label: "送货单号",
          width: "180",
          fixed: ""
        }), _createVNode(_component_el_table_column, {
          prop: "source",
          label: "来源系统"
        }), _createVNode(_component_el_table_column, {
          prop: "supplier",
          label: "供应商/生产厂名",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "sku",
          label: "sku/产品型号",
          width: "180",
          lign: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "物料名称",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "check_status",
          label: "检测状态",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "检测报告",
          width: "180",
          align: "center"
        }, {
          default: _withCtx(scope => [!scope.row.report_url ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
            key: 0,
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": function (res, file, file_list) {
              return $options.handleSuccess(res, file, file_list, scope.row);
            },
            "show-file-list": false,
            name: "file",
            ref: "upload",
            "on-change": $options.handleChange
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [_createElementVNode("span", {
              class: "text_blue Cursor m-r-10"
            }, "上传", -1)])),
            _: 2,
            __: [12]
          }, 1032, ["action", "on-success", "on-change"])), [[_directive_loading, $data.loading, void 0, {
            fullscreen: true,
            lock: true
          }]]) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", {
            onClick: $event => $options.downloadTemplate(scope.row),
            class: "text_blue Cursor m-r-10"
          }, "下载", 8, _hoisted_4), _createElementVNode("span", {
            onClick: $event => $options.deleteFile(scope.row, scope.$index),
            class: "text_blue Cursor"
          }, "删除", 8, _hoisted_5)]))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "confirm_status",
          label: "确认状态",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "num",
          label: "送检数量(pcs)",
          width: "180",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "depot",
          label: "送货仓库",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "supplier_addr",
          label: "供应商地址",
          width: "180",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "contact_mobile",
          label: "联络人/电话号码",
          width: "180",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "scheck_date",
          label: "送检日期",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "check_date",
          label: "检测日期",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "check_user",
          label: "检测人",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "confirm_name",
          label: "确认人",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "remark",
          label: "备注",
          width: "180",
          align: "center"
        })]),
        _: 1
      }, 8, ["data", "header-cell-style", "onSelectionChange", "row-key"]), _createVNode(_component_el_row, {
        class: "p-20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_pagination, {
          onSizeChange: $options.changePageSize,
          onCurrentChange: $options.changePage,
          "current-page": $data.filter.page,
          "page-sizes": [50, 100, 150, 200],
          "page-size": $data.filter.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: $data.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })])]);
}